//  date to define
export const month = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const getDateHandler = (date) => {
  const dateTime = new Date(date);
  const day =
    dateTime.getDate() +
    " " +
    month[dateTime.getMonth()] +
    " " +
    dateTime.getFullYear();
  return day;
};
